import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarDadosIniciarPedido(axios) {        
    let parametros = {
      operacao: 'buscarDadosIniciarPedido' 
    }

    let retorno = {}

    await axios.santriGET('/rest/orcamento', parametros, 25, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data)
    })
    .catch(error => {      
      retorno = Biblioteca.retornoRequisicao('S', error, undefined)
    })

    return retorno
  },
}


// WEBPACK FOOTER //
// ./src/components/Rest/ROrcamento/ROrcamentoBuscarDadosIniciarPedido.js